import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation, useSearchParams} from 'react-router-dom'
import ContainerAtom from '../../@atoms/to_layout/container/container.atom'
import FooterAtom from '../../@atoms/to_content/footer/footer.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import {RootState} from '../../store_redux'
import brandService from '../../services/brand.service'
import {LinkProps} from '../../props_reusable/labels'
import utils from '../../utils'

const AppFooterComponent: React.FC = function ({...props}) {
  const [footerLinks, setFooterLinks] = useState<LinkProps>()
  const [params] = useSearchParams()
  const orderGUID = params.get('orderGUID') || ''
  const location = useLocation()
  const isAppFooterAllowed = utils.isWhiteListedPage(location.pathname)
  const labels = useSelector((state: RootState) => state.labels)
  const isLabelEmpty = utils.isObjectEmpty(labels)

  const setEmptyLinks = () => {
    setFooterLinks({
      link1: '',
      link2: '',
      link3: '',
      link4: '',
      link5: '',
    })
  }

  // eslint-disable-next-line
  useEffect(
    () => {
      const source = utils.generateCancelTokenSource()
      const config = {
        cancelToken: source.token,
      }
      if (orderGUID) {
        if (isAppFooterAllowed) {
          brandService
            .getFooterLinks<LinkProps>(orderGUID, config)
            .then(setFooterLinks)
            .catch(setEmptyLinks)
        }
      }
      return () => source.cancel()
    },
    // eslint-disable-next-line
    [isAppFooterAllowed, orderGUID],
  )

  if (!isAppFooterAllowed) return null
  return (
    <ContainerAtom ap_type="app_footer_wrapper">
      <ContainerAtom ap_type="app_footer" {...props}>
        {!isLabelEmpty && footerLinks ? (
          <FooterAtom label={labels.footer} routes={footerLinks} />
        ) : (
          <SkeletonAtom ap_type="app_footer_skeleton" />
        )}
      </ContainerAtom>
    </ContainerAtom>
  )
}
export default AppFooterComponent
